import { getIncentiveCategory } from "../../../utils/utils";

export const createFormState = (data) => {
  const medicineNameNospace = data?.productName?.replace(/\s/g, "");
  return {
    medicineName: data?.productName,
    medicineNameBase: data.productBrand,
    medicineId: data.productId ? data.productId : undefined,
    itemtype: data.itemType.label ? data.itemType.label : null,
    categoryId: data.category?.categoryId,
    medicinePackaging: data.isRecipe ? "" : data.medicinePackaging ? data.medicinePackaging : null,
    therapeutic: data.therapeutic ? data.therapeutic.label : null,
    subtherapeutic: data.subTherapeutic ? data.subTherapeutic : null,
    barcode: data.barcode ? data.barcode : null,
    medicineShortCode: data.medicineShortCode ? data.medicineShortCode : null,
    manufacturerName: data.manufacturer.label ? data.manufacturer.label : null,
    manufacturerGroupName: data.manufacturerGroup
      ? data.manufacturerGroup
      : null,
    manufacturerId: data.manufacturer.id ? data.manufacturer.id : null,
    medicineGstPer: data.gst?.id === "" ? null : data.gst?.id,
    minStock: data.minStock ? data.minStock : null,
    maxStock: data.maxStock ? data.maxStock : null,
    minDays: data.minDays ? data.minDays : null,
    maxDays: data.maxDays ? data.maxDays : null,
    hsnCode: data.hsnCode ? data.hsnCode : null,
    rack: data.rack ? data.rack : null,
    rack1: data.rack1 ? data.rack1 : null,
    remarks: data.remarks,
    description: data?.description || null,
    istb: data.isTb,
    disableAutoBarcodePrinting: data.disableAutoBarcodePrinting,
    isLoose: data.isLoose,
    divisor: data.divisor ? data.divisor : null,
    scheduledId: data.scheduleType.id ? data.scheduleType.id : undefined,
    genericDosage: data.genericDosage
      ? data.genericDosage
          .map((value) => value)
          .sort()
          .join(", ")
          .toString()
      : undefined,
    medicineNameNospace: data?.productNameNospace,
    medicineNameDetailed: data?.productNameDetailed,
    //divisorUnit: data.divisorUnit,
    discPer: data.discPer,
    maxDiscount: data.maxDiscount,
    tcsPer: data.tcsPer,
    gccess: data.gccess,
    vat: data.vat,
    boxMrp: data.boxMrp,
    boxPtr: data.boxPtr,
    markup: data.markup,
    passiveMrp: data.passiveMrp,
    passiveCp: data.passiveCp,
    isBanned: data.isBanned,
    isDiscontinued: data.isDiscontinued,
    isUndeliverable: data.isUndeliverable,
    isActive: data.isActive,
    skipFromApo: data.skipFromApo,
    skipFromShortBook: data.skipFromShortBook,
    blockExpiryPrint: data.blockExpiryPrint,
    allowWeb: data.allowWeb,
    storage: data.storage || null,
    isChronic: data.isChronic,
    outerQtyPack: data.outerQtyPack,
    marketerName: data.marketer?.label || null,
    marketerId: data.marketer?.id || null,
    allowDiscount: data.allowDiscount,
    isReturnable: data.isReturnable,
    sellingPrice: data.sellingPrice,
    rateItemwise: data.rateItemwise,
    isRecipe: data.isRecipe,
    // recipeItem: !data.isRecipe ? undefined : data.recipeItem,
    recipeItem: data?.isLoose || data.isRecipe ? data?.recipeItem : undefined,
    computeMinMax: data.computeMinMax,
    autoOrderDays: data.autoOrderDays || null,
    b2BOffset: data.b2BOffset,
    b2bSellingPrice: data.b2bSellingPrice,
    b2bForceSellingPrice: data.b2bForceSellingPrice || false,
    dpPercentage: data.dpPercentage ?? null,
    recipeType: data.recipeType,
    potency: data.potency,
    modeCategory: data.modeCategory,
    incentiveCategory: getIncentiveCategory(data?.recipeType),
    forceRecipe: data.forceRecipe,
    medicineForm: data.medicineForm,
    isPackingMaterial: data.isPackingMaterial,
  };
};
